'use strict';

var React = require('react');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SvgIcon = require('material-ui/lib/svg-icon');

var ChevronDown = React.createClass({
  displayName: 'ChevronDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z' })
    );
  }

});

module.exports = ChevronDown;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-mdi/icons/chevron-down.js
// module id = 331
// module chunks = 0